<template>
  <div class="tcourse-filter tcourse-filter--simple">
    <p>{{ $t('filtering') }} <strong>{{ $t('course_offers') }}</strong></p>
    <b-form-select
      v-model="field_id"
      :options="fieldOptions"
      class="form-control"
    >
      <template slot="first">
        <option value="">
          {{ $t('select_methodology') }}
        </option>
      </template>
      <slot />
    </b-form-select>
    <b-form-select
      v-model="course_id"
      :options="courses"
      class="form-control"
    >
      <template slot="first">
        <option value="">
          {{ $t('select_course') }}
        </option>
      </template>
      <slot />
    </b-form-select>
    <b-form-select
      v-if="showDate"
      v-model="place"
      :options="placeOptions"
      class="form-control"
    >
      <template slot="first">
        <option value="">
          {{ $t('select_place') }}
        </option>
      </template>
      <slot />
    </b-form-select>
    <b-form-select
      v-if="!online"
      v-model="date"
      :options="dateOptions"
      class="form-control"
      ref="course"
    >
      <template slot="first">
        <option value="">
          {{ $t('select_month') }}
        </option>
      </template>
      <slot />
    </b-form-select>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import { isEmpty } from 'ramda';

const { mapFields } = createHelpers({
  getterType: 'getFilterField',
  mutationType: 'updateFilterField',
});

export default {
  name: 'CertificationsFilter',
  props: {
    online: {
      type: Boolean,
      default: false,
    },
    virtual: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapFields(['field_id', 'course_id', 'date', 'place']),
    ...mapState({
      fieldOptions: state => state.filterAttributes.fields,
      courseOptions: state => state.filterAttributes.courses,
      placeOptions: state => state.filterAttributes.places,
      dateOptions: state => state.filterAttributes.dates,
    }),
    showDate() {
      return !(this.online || this.virtual);
    },
    courses() {
      if (isEmpty(this.field_id)) {
        return this.courseOptions;
      }
      return this.courseOptions.filter(course => course.field_id === this.field_id);
    },
  },
  watch: {
    field_id() {
      this.course_id = '';
    },
  },
};
</script>

<i18n>
{
  "cs": {
    "filtering": "Filtrování",
    "course_offers": "nabídky kurzů",
    "select_methodology": "Vyberte metodiku",
    "select_course": "Vyberte kurz",
    "select_place": "Vyberte město",
    "select_month": "Vyberte měsíc"
  },
  "sk": {
    "filtering": "Filtrovanie",
    "course_offers": "ponuka kurzov",
    "select_methodology": "Vyberte metodiku",
    "select_course": "Vyberte kurz",
    "select_place": "Vyberte mesto",
    "select_month": "Vyberte mesiac"
  },
  "en": {
    "filtering": "Filtering",
    "course_offers": "course offers",
    "select_methodology": "Select methodology",
    "select_course": "Select course",
    "select_place": "Select place",
    "select_month": "Select month"
  }
}
</i18n>
